import { RefObject, useCallback } from 'react'

type PageBottomProps = {
  containerRef?: RefObject<HTMLDivElement>
  containerClass: string
}

export const usePageBottom = ({
  containerRef,
  containerClass
}: PageBottomProps) => {
  const getIsPageBottom = useCallback(() => {
    // 'footer' class use as general footer block class
    const footerElement = document.querySelector('[class*="footer"]')
    const footerHeight = footerElement?.clientHeight || 0
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop
    const scrollHeight = winScroll + window.innerHeight
    const docHeight = document.documentElement.offsetHeight - footerHeight
    const isBottom = scrollHeight > docHeight

    return isBottom
  }, [window, document])

  const getIsContainerBottom = useCallback(() => {
    const itemsList = document.querySelector(`[class*="${containerClass}"]`)
    if (itemsList && containerRef?.current) {
      const itemsBound = itemsList.getBoundingClientRect()
      const basicHeight = containerRef?.current.clientHeight
      const currentHeight = itemsList.clientHeight
      const top = itemsBound?.top
      const innerHeight = top ? Math.abs(top) + basicHeight : basicHeight
      const isBottom = currentHeight < innerHeight

      return isBottom
    }
    return false
  }, [])

  return {
    getIsPageBottom,
    getIsContainerBottom
  }
}

export default usePageBottom
